import "./CaseStudies.module.css";
import Header from "@/reusable_sections/Header";
import CaseStudiesHero from "./sections/CaseStudiesHero";
import CaseStudyOne from "./sections/CaseStudyOne";
import CaseStudyTwo from "./sections/CaseStudyTwo";
import CaseStudiesCta from "./sections/CaseStudiesCta";
import Footer from "@/reusable_sections/Footer";
export default function CaseStudiesPage() {
  return <div>
      <Header />
      <CaseStudiesHero />
      <CaseStudyOne />
      <CaseStudyTwo />
      <CaseStudiesCta />
      <Footer />
    </div>;
}